export default __webpack_public_path__ + "static/media/I0007.b16c0c04.png";